import React from 'react';

import {
  Actions as UIActions,
  Action,
  PlayArrowIcon,
  StopIcon,
  FileCopyIcon,
  EditIcon,
  DeleteIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_START,
  ACTION_STOP,
  ACTION_DUPLICATE,
  ACTION_EDIT,
  ACTION_REMOVE,
} from 'scenes/Integrations/constants';

export const Actions = ({
  actions,
  onDuplicate,
  onEdit,
  onStart,
  onStop,
  onRemove,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <UIActions limit={3}>
          {isActionAllowed(ACTION_START) ? (
            <Action
              id={ACTION_START}
              icon={<PlayArrowIcon />}
              label={'Activate'}
              onClick={onStart}
            />
          ) : null}
          {isActionAllowed(ACTION_STOP) ? (
            <Action
              id={ACTION_STOP}
              icon={<StopIcon />}
              label={'Deactivate'}
              onClick={onStop}
            />
          ) : null}
          <Action
            id={ACTION_DUPLICATE}
            icon={<FileCopyIcon />}
            label={'Duplicate'}
            disabled={!isActionAllowed(ACTION_DUPLICATE)}
            onClick={onDuplicate}
          />
          <Action
            id={ACTION_EDIT}
            icon={<EditIcon />}
            label={'Edit'}
            disabled={!isActionAllowed(ACTION_EDIT)}
            onClick={onEdit}
          />
          <Action
            id={ACTION_REMOVE}
            icon={<DeleteIcon />}
            label={'Delete'}
            disabled={!isActionAllowed(ACTION_REMOVE)}
            onClick={onRemove}
          />
        </UIActions>
      )}
    </Permissions>
  );
};

export default Actions;
